export function highlight(text: string, search: string, modifier?: string): string {
	const pattern = new RegExp(search, 'i');
	const mod = (modifier && ` a-highlight--${modifier}`) || '';

	return (text && search) ? text.replace(pattern, `<strong class="a-highlight${mod}">${pattern.exec(text)}</strong>`) : text;
}
